import { api } from 'app/utils/api/helpers'

export const updateAddressHistoryEndDate = (data) => {
  return api.post(`/sm/phu/address_end_date`, data)
}

export const updateEmploymentEndDate = (data) => {
  return api.post(`/sm/phu/emp_end_date`, data)
}
